import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {FormGroup, Select} from "@unibuddy/patron";
import {string} from "yup";

import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {CustomAttributeType} from "./CustomAttributeConstants";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_DATE_OF_ENTRY, INTL_SELECT_A_DATE} from "../../../../../translations/signup";
import {INTL_DATE_OF_ENTRY_REQUIRED} from "../../../../../translations/validations";
import {entryMonthOptions} from "./DateOfEntryUtils";

export function DateOfEntryFormField() {
    const {t} = useTranslation([IntlNamespaces.SIGNUP, IntlNamespaces.VALIDATIONS]);
    const {entries, customAttributes} = useUniversity();

    const yearOfEntry = customAttributes?.find(
        (attr) => attr.type === CustomAttributeType.YEAR_OF_ENTRY,
    );

    if (!yearOfEntry) return null;

    let yearOfEntryValidation = string();
    if (yearOfEntry && yearOfEntry.required) {
        yearOfEntryValidation = yearOfEntryValidation.required(
            t(
                `${IntlNamespaces.VALIDATIONS}:${INTL_DATE_OF_ENTRY_REQUIRED.key}`,
                INTL_DATE_OF_ENTRY_REQUIRED.defaultValue,
            ),
        );
    }

    return (
        <FormGroup
            id="dateOfEntry"
            initialValue=""
            validation={yearOfEntryValidation}
            label={t(
                `${IntlNamespaces.SIGNUP}:${INTL_DATE_OF_ENTRY.key}`,
                INTL_DATE_OF_ENTRY.defaultValue,
            )}
        >
            <Select
                placeholder={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_A_DATE.key}`,
                    INTL_SELECT_A_DATE.defaultValue,
                )}
                name="dateOfEntry"
                required={yearOfEntry.required}
                formatValue={(e: string) => e}
            >
                {entryMonthOptions(entries.entryMonths)}
            </Select>
        </FormGroup>
    );
}
